import React from 'react';

import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  spacer: {
    flexGrow: 1,
  },
}));

interface SpacerProps {
  className?: string;
}

export function Spacer({ className }: SpacerProps): JSX.Element {
  const { classes } = useStyles();
  return <div className={clsx(className, classes.spacer)} />;
}
